import AttemptQuestion from '../../../components/exams-components/quiz-questionbank/AttemptQuestion'
import { Box, Button, Dialog, Paper, Typography, useTheme, IconButton } from '@mui/material'
import quizSubmitSuccessfulImg from '../../../assets/illustrations/quiz-completed.svg'
import DataLoadingSpinner from '../../../components/common/DataLoadingSpinner'
import { useQuizAndQuestionbankStore } from '../../../store/quizandquestionbank.store'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Icons, latexDelimiters, secondsToHMS } from '../../../utils/utilities'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { observer } from 'mobx-react'
import api from '../../../service/api'
import Latex from 'react-latex-next'
import dayjs from 'dayjs'

const Timer = ( { deadline, onEnd } ) => {

    const [timerValue, setTimerValue] = useState( '' )
    const intervalRef = useRef()

    useEffect( () => {
        const target = deadline || dayjs().add( 5, 'minutes' )

        intervalRef.current = setInterval( () => {
            const diff = ( new Date( target ) - new Date() ) / 1000
            if ( diff <= 0 ) {
                clearInterval( intervalRef.current )
                setTimerValue( "00:00:00" )
                if ( onEnd && typeof onEnd === 'function' ) {
                    onEnd()
                }
            } else {
                setTimerValue( secondsToHMS( diff ) )
            }


        }, 1000 )



        return () => {
            console.log( "TIMER CLEANED UP!" )
            clearInterval( intervalRef.current )
        }
    }, [deadline, onEnd] )

    return <Typography variant="h6" fontSize="18px" color="primary" fontWeight="500">{timerValue}</Typography>
}


const QuizAttempt = observer( () => {

    const [loading, setLoading] = useState( true )
    const [viewScoresMode, setViewScoresMode] = useState( false )
    const [submittingAnswers, setSubmittingAnswers] = useState( false )
    const [scoresDetails, setScoresDetails] = useState( {} )
    const [timerValue, setTimerValue] = useState( '' )
    const [remainingTime, setRemainingTime] = useState( null )
    const [hasAlreadyTakenTheQuiz, setHasAlreadyTakenTheQuiz] = useState( false )
    const [selectedQuestionDetails, setSelectedQuestionDetails] = useState( null )
    const [attemptDeadLine, setAttemptDeadLine] = useState( null )

    const { palette, border } = useTheme()

    const { quiz_id, instance_id, attempt_id } = useParams()

    const navigate = useNavigate()

    const QuizStore = useQuizAndQuestionbankStore()

    const setQuestion = ( index ) => {
        setSelectedQuestionDetails( { index, id: QuizStore.getQuizAttemptQuestions[index]?.id } )
    }

    const resetCurrentQuestion = () => {
        QuizStore.setAttemptingAnswers( { ...QuizStore.getAttemptingAnswers, [selectedQuestionDetails?.id]: undefined } )
    }

    const goToNextQuestion = () => {
        const { index: currentIndex } = selectedQuestionDetails
        if ( currentIndex + 1 >= QuizStore.getQuizAttemptQuestions?.length )
            setQuestion( 0 )
        else setQuestion( currentIndex + 1 )
    }

    const fetchScores = async () => {
        try {
            const { data: { data } } = await api.quiz.fetchAttemptScore( quiz_id, instance_id, attempt_id )
            setScoresDetails( data )
            console.log( data )
            setViewScoresMode( true )
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Something went wrong whie fetching scores!" )
        }
    }

    const submitAnswers = async () => {
        setSubmittingAnswers( true )
        const answeredQuestions = Object.keys( QuizStore.getAttemptingAnswers )
        if ( answeredQuestions.length === QuizStore.getQuizAttemptQuestions.length ) {
            const multipleSelectionQuestions = QuizStore.getQuizAttemptQuestions.filter( q => q.selection_type === 'multiple' )
            let hasAnsweredAll = true
            for ( let i = 0; i < multipleSelectionQuestions.length; i++ ) {
                const ques = multipleSelectionQuestions[i]
                const correctAnswer = QuizStore.getAttemptingAnswers[ques.id]?.filter( a => a === true ).length
                if ( correctAnswer === 0 ) {
                    hasAnsweredAll = false
                    break
                }
            }
            if ( hasAnsweredAll ) {
                if ( await QuizStore.submitQuizAnswers( quiz_id, instance_id, attempt_id ) ) {
                    setHasAlreadyTakenTheQuiz( true )
                    // navigate( `/student/quiz/${quiz_id}/${instance_id}` )
                } else
                    toast( "Couldn't submit your answers! something went wrong" )
            } else
                toast( "Please answer all the questions" )
        } else {
            toast( "Please answer all the questions" )
        }
        setSubmittingAnswers( false )
    }

    const submitOnTimer = useCallback( async () => {
        let success = false
        let retries = 0
        while ( !success ) {
            success = await QuizStore.submitQuizAnswers( quiz_id, instance_id, attempt_id )
            retries += 1
            if ( retries > 5 ) {
                toast( "Error while submitting quiz!" )
                return
            }
        }
        if ( success ) {
            setHasAlreadyTakenTheQuiz( true )
            localStorage.removeItem( `quizinstance-${instance_id}-timeleft` )
        }
    }, [QuizStore, attempt_id, instance_id, quiz_id] )

    useEffect( () => {
        const getData = async () => {
            const { success, message } = await QuizStore.fetchQuizInstanceForStudent( quiz_id, instance_id )
            if ( success ) {
                if ( +QuizStore.getQuizInstance?.attempted > 0 )
                    setHasAlreadyTakenTheQuiz( true )
                else {
                    const { success, message } = await QuizStore.fetchQuizQuestionsForAttempt( quiz_id, instance_id, attempt_id )
                    if ( success ) {
                        setSelectedQuestionDetails( { index: 0, id: QuizStore.getQuizAttemptQuestions[0]?.id } )
                        if ( QuizStore.getQuizInstance?.quiz_duration ) {
                            let duration = QuizStore.getQuizInstance?.quiz_duration?.split( ":" )
                            let timeRemainingInSec = ( +duration[0] * 60 * 60 ) + ( +duration[1] * 60 )
                            setAttemptDeadLine( dayjs().add( timeRemainingInSec, 'seconds' ) )
                        }
                        QuizStore.setAttemptingAnswers( JSON.parse( localStorage.getItem( 'quiz_local_answer' ) || '{}' ) )
                    } else {
                        toast( message )
                        navigate( `/student/home` )
                    }
                }
            }
            else {
                toast( message )
                navigate( `/student/home` )
            }
            setLoading( false )
        }
        getData()

    }, [QuizStore, quiz_id, instance_id, attempt_id, navigate] )

    return (
        <Box padding="20px" display={{ md: "flex", xs: "block" }} flexDirection="column" flexGrow={1} overflow="auto">
            {!hasAlreadyTakenTheQuiz && !loading && <Paper sx={{ flexGrow: { md: 1, xs: "initial" }, display: "flex", flexDirection: "column", minHeight: "550px" }}>
                <Box display="flex" padding="10px 20px" justifyContent="space-between" gap="20px" flexWrap="wrap" alignItems="center">
                    <Typography variant="h6" color="primary" fontWeight="700">Quiz #{QuizStore.getQuizInstance?.id}</Typography>
                    {attemptDeadLine && <Timer onEnd={submitOnTimer} deadline={attemptDeadLine} />}
                </Box>
                {<Box display="flex" flexDirection={{ xs: "column-reverse", md: "row" }} flexGrow={1} overflow={{ md: "auto", xs: "initial" }}>
                    <Box className='slim-custom-scrollbar' borderRight={{ md: "2px solid #d3d3d3", xs: "none" }} display="flex" flexGrow={1} flexDirection="column" overflow="auto">
                        {QuizStore.getQuizInstance && <Box display="flex" flexDirection="column" gap='20px' padding={{ md: "20px", xs: "10px" }} paddingTop="0">
                            <Box display="flex" justifyContent="space-between" flexWrap="wrap" alignItems="stretch" overflow="hidden" gap={{ md: "20px", xs: "10px" }} border={`1px solid ${palette.primary.dark}`} borderRadius="5px">
                                <Typography variant="h6" color="primary" padding="10px 20px">{QuizStore.getQuizInstance.title}</Typography>
                                <Box display="flex" justifyContent="flex-end" alignItems="center" flexGrow={1} gap={{ md: "20px", xs: "10px" }}>
                                    <Typography>
                                        {QuizStore.getAnsweredCount} / {QuizStore.getQuizAttemptQuestions?.length}
                                    </Typography>
                                    <Box overflow="hidden" boxShadow="inset 1px 0px 5px 1px #DDD9D9" bgcolor="#DDD9D9" borderRadius="10px" height="10px" width="35%">
                                        <Box height="100%" sx={{ transition: "200ms" }} bgcolor={palette.success.main} width={`${QuizStore.getAnsweredCount * 100 / QuizStore.getQuizAttemptQuestions?.length}%`}></Box>
                                    </Box>
                                    <Button onClick={submitAnswers} disabled={submittingAnswers} variant='contained' sx={{ borderRadius: "0", height: "100%" }} disableElevation >
                                        Submit
                                    </Button>
                                </Box>
                            </Box>
                        </Box>}
                        <Box paddingRight="20px" flexGrow={1} display="flex" flexDirection="column" overflow="auto" >
                            {selectedQuestionDetails && QuizStore.getQuizAttemptQuestions?.length > 0 && <Box className='slim-custom-scrollbar' flexGrow={1} overflow="auto" padding="20px" display="flex" flexDirection="column" gap="20px">
                                <Typography variant="body1" fontSize="14px" marginTop="-10px" marginBottom="10px" >Question {( selectedQuestionDetails?.index || 0 ) + 1}</Typography>
                                <AttemptQuestion goToNextQuestion={goToNextQuestion} resetCurrentQuestion={resetCurrentQuestion} key={selectedQuestionDetails?.id} index={selectedQuestionDetails?.index} question={QuizStore.getQuizAttemptQuestions[selectedQuestionDetails?.index]} />
                            </Box>}
                        </Box>
                    </Box>
                    {/* {QuizStore.getQuizAttemptQuestions?.length > 0 && <Box>
                        <Box bgcolor={palette.grey[400]} width="3px" height="400px" ></Box>
                    </Box>} */}
                    {QuizStore.getQuizAttemptQuestions?.length > 0 && <Box padding="20px" minWidth="250px" maxWidth={{ md: "260px", xs: "auto" }} display="flex" flexDirection="column" gap="20px">
                        <Typography variant="h6">Questions</Typography>
                        <Box display="flex" flexWrap="wrap" gap="20px" alignItems="center">
                            <Typography
                                paddingLeft="20px"
                                position="relative"
                                sx={{
                                    '&::before': {
                                        content: `''`,
                                        position: "absolute",
                                        left: "0",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "10px",
                                        width: "10px",
                                        background: palette.success.main,
                                        borderRadius: "2px",
                                    }
                                }}
                                variant='subtitle1'
                            >
                                Answered
                            </Typography>
                            <Typography
                                paddingLeft="20px"
                                position="relative"
                                sx={{
                                    '&::before': {
                                        content: `''`,
                                        position: "absolute",
                                        left: "0",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        height: "10px",
                                        width: "10px",
                                        background: palette.primary.main,
                                        borderRadius: "2px",
                                    }
                                }}
                                variant='subtitle1'
                            >
                                Selected
                            </Typography>
                        </Box>
                        <Box display="flex" flexWrap="wrap" gap="20px">
                            {QuizStore.getQuizAttemptQuestions?.map( ( ques, index ) => {

                                const isSelected = selectedQuestionDetails?.index === index
                                let isAnswered = false

                                if ( ques.selection_type === 'single' && QuizStore.getAttemptingAnswers[ques.id] )
                                    isAnswered = true
                                else if ( ques.selection_type !== 'single' && QuizStore.getAttemptingAnswers[ques.id] && QuizStore.getAttemptingAnswers[ques.id]?.length > 0 )
                                    isAnswered = true

                                return (
                                    <Box
                                        onClick={
                                            () => setQuestion( index )
                                        }
                                        bgcolor={isAnswered ? palette.success.main : isSelected ? palette.primary.light : "none"}
                                        sx={{
                                            cursor: "pointer",
                                            '&:hover': {
                                                background: !isAnswered && !isSelected && palette.rowHover
                                            }
                                        }}
                                        color={( isSelected || isAnswered ) ? "white" : palette.defaultColor}
                                        key={index}
                                        width="30px"
                                        height="30px"
                                        border={`2px solid ${isAnswered ? isSelected ? palette.primary.light : palette.success.main : isSelected ? palette.primary.light : "#d3d3d3"}`}
                                        borderRadius="5px"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                    >
                                        <Typography variant='h6' fontSize="16px">{index + 1}</Typography>
                                    </Box>
                                )
                            } )}
                        </Box>
                    </Box>}
                </Box>}

                {/* {hasAlreadyTakenTheQuiz && <BlockMessage
                    actions={[{ actionIcon: Icons.default.AnalyticsIconOutlined, action: () => navigate( `/student/quiz/${quiz_id}/${instance_id}` ), label: "Check your scores" }]}
                    message='You have already submitted your answers for this quiz!' />} */}


            </Paper>}
            {loading && <DataLoadingSpinner waitingMessage="Loading quiz details..." />}
            {!loading && <Dialog open={( hasAlreadyTakenTheQuiz || ( viewScoresMode && hasAlreadyTakenTheQuiz ) )} slotProps={{
                paper: { className: 'slim-custom-scrollbar', sx: { width: "60%", maxWidth: "600px" } }
            }}>
                {!viewScoresMode && <Box bgcolor="#FBCF58" justifyContent="center" flexGrow={1} alignItems="center" display="flex" flexDirection="column" gap="20px" padding="50px">
                    <img width="70%" src={quizSubmitSuccessfulImg} alt="Submitted successfully" />
                    <Box alignItems="center" display="flex" flexDirection="column">
                        <Typography color={palette.common.black} gutterBottom variant="h5">Congratulation!</Typography>
                        <Typography color={palette.common.black} variant="body2">You have successfully completed the quiz</Typography>
                    </Box>
                    <Box display="flex" alignItems="center" gap="20px" flexWrap="wrap">
                        <Button onClick={fetchScores} sx={{ paddingX: "40px", fontSize: "12px", fontWeight: "bolder", marginTop: "20px", background: 'white', borderColor: "white", '&:hover': { background: "white", borderColor: "white" } }} variant='outlined' color='primary' >View Score</Button>
                        <Button onClick={() => navigate( '/student/home' )} sx={{ paddingX: "40px", fontSize: "12px", fontWeight: "bolder", marginTop: "20px", background: 'white', borderColor: "white", '&:hover': { background: "white", borderColor: "white" } }} variant='outlined' color='primary' >Back to home</Button>
                    </Box>
                </Box>}
                {viewScoresMode && <Box bgcolor={palette.background.paper} flexGrow={1} display="flex" flexDirection="column">
                    <Box position="sticky" top="0" display="flex" alignItems="center" justifyContent="space-between" borderBottom={border[1]} padding="10px 20px" bgcolor={palette.background.paper}>
                        <Typography variant="h6">{QuizStore.getQuizInstance.title}</Typography>
                        <IconButton size="small" onClick={() => setViewScoresMode( false )}>
                            {Icons.default.CancelIcon}
                        </IconButton>
                    </Box>
                    <Box>
                        <Box padding="10px 20px" bgcolor={palette.contentBg} position="sticky" top="55px" display="flex" alignItems="center" gap="30px">
                            <Typography variant="h6">OVERALL SCORE</Typography>
                            <Typography variant="h6"> <strong>{scoresDetails?.total_score} / {scoresDetails?.max_score}</strong></Typography>
                        </Box>

                        <Box display="flex" gap="20px" alignItems="center" borderBottom={border[1]} padding="20px">
                            <Box display="flex" gap="10px" alignItems="center">
                                <Box sx={{ width: "15px", borderRadius: "50%", height: "15px", border: `2px solid ${palette.success.dark}` }}></Box>
                                <Typography variant='subtitle2' fontSize="12px" >Correct option</Typography>
                            </Box>
                            <Box display="flex" gap="10px" alignItems="center">
                                <Box sx={{ width: "15px", borderRadius: "50%", bgcolor: palette.success.dark, height: "15px", border: `2px solid ${palette.success.dark}` }}></Box>
                                <Typography variant='subtitle2' fontSize="12px" >Answered, correctly</Typography>
                            </Box>
                            <Box display="flex" gap="10px" alignItems="center">
                                <Box sx={{ width: "15px", borderRadius: "50%", bgcolor: palette.error.light, height: "15px", border: `2px solid ${palette.error.dark}` }}></Box>
                                <Typography variant='subtitle2' fontSize="12px" >Answered, but incorrect</Typography>
                            </Box>
                        </Box>

                        <Box display="flex" padding="0 20px 20px 20px" marginTop="30px" flexDirection="column" gap="20px">
                            {Object.keys( scoresDetails?.scores || {} ).map( ( quesId, index ) => {
                                const ques = scoresDetails?.scores[quesId]
                                return <Box key={index}>
                                    {ques.given < 0 ? <Typography padding="5px 10px" marginBottom="20px" borderRadius="5px" width="fit-content" bgcolor={palette.errorMessage.light + 22} variant='subtitle2' color="errorMessage.main"><em>Not Answered</em></Typography> :
                                        <Typography padding="5px 10px" marginBottom="10px" borderRadius="5px" width="fit-content" bgcolor={palette.primary.light + 22} variant='subtitle2' display="block" color="primaryDark.main"><em>Answered</em></Typography>}

                                    <Box color={palette.contrstText} className='questionbank-wysiwyg-container' fontWeight="bold" marginTop="-5px" fontSize="14px">
                                        <Latex delimiters={latexDelimiters}>{ques.question_text}</Latex>
                                    </Box>
                                    <Typography variant='body2' color="textSecondary"><em>{ques.selection_type}</em></Typography>
                                    <Box marginTop="10px" display="flex" flexDirection="column" gap="10px">
                                        {ques.options.map( ( option, optionIndex ) => {
                                            const isCorrect = ques.selection_type === "single" ? +ques.correct_answer === optionIndex : ques.options_status[optionIndex]
                                            const hasAnswered = ques.selection_type === "single" ? +ques.given === optionIndex : ques.given.includes( optionIndex )
                                            return (
                                                <Box
                                                    padding="10px"
                                                    border={border[1]}
                                                    borderRadius="5px"
                                                    bgcolor={hasAnswered ? ( hasAnswered && isCorrect ) ? "success.dark" : "error.light" : "none"}
                                                    borderColor={isCorrect ? "success.dark" : hasAnswered ? "errorMessage.dark" : palette.borderColor}
                                                    sx={{ borderWidth: isCorrect || hasAnswered ? "2px" : "1px" }}
                                                    display="flex"
                                                    marginBottom="2px"
                                                    alignItems="flex-start"
                                                    gap="10px"
                                                    key={optionIndex}
                                                >
                                                    <Typography padding="2px 2px 0px 2px" variant="subtitle2" fontSize="12px" sx={{ aspectRatio: 1 / 1 }} bgcolor={palette.greyedOut} border={`1px solid ${palette.borderColor}`} display="flex" alignItems="center" justifyContent="center" width='20px' borderRadius="50%"
                                                        fontWeight={( isCorrect || hasAnswered ) ? "bolder" : "regular"} color={isCorrect ? "success" : hasAnswered ? "error" : palette.common.font}>{optionIndex + 1}</Typography>
                                                    <Box variant="subtitle2" className='questionbank-wysiwyg-container' color={( hasAnswered ) ? "white" : palette.common.font}>
                                                        <Latex delimiters={latexDelimiters}>{option.option_text}</Latex>
                                                    </Box>
                                                </Box>
                                            )
                                        } )}
                                    </Box>
                                </Box>
                            } )}
                        </Box>
                    </Box>
                </Box>}
            </Dialog>}
        </Box>
    )
} )

export default QuizAttempt
